import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { useAuth } from './useAuth';

const BrandingContext = createContext(null);

const DEFAULTS = {
  ttcLogo: null,
  customerLogo: null,
  background: { url: null, enabled: false, placement: 'toolbars' },
  footerCompany: 'Toledo Ticket Technologies',
  announcement: { enabled: false, text: '' },
  defaultProductImage: null,
};

export function BrandingProvider({ children }) {
  const { user } = useAuth();
  const [branding, setBranding] = useState(DEFAULTS);

  const refresh = useCallback(() => {
    api.get('/api/branding/config')
      .then(r => setBranding({
        ...DEFAULTS,
        ...r.data,
        background: { ...DEFAULTS.background, ...(r.data.background || {}) },
      }))
      .catch(() => setBranding(DEFAULTS));
  }, []);

  // Refetch once auth resolves and whenever the user changes, so a tenant's
  // logo appears right after login and clears on logout.
  useEffect(() => { if (user !== undefined) refresh(); }, [user, refresh]);

  return (
    <BrandingContext.Provider value={{ ...branding, refresh }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext) || { ...DEFAULTS, refresh: () => {} };
}
